import { Config } from "../config/Config";

export const Routes = {
    Home: Config?.url + '/',
    PageNotFound:Config?.url + '*',
    Login: Config?.url + '/login',
    Signup:Config.url + '/signup',
    CompleteProfile: Config.url + '/signup/complete-profile',
    Profile:Config.url + '/profile',
    ChangePassword: Config.url + '/change-password',
    Faq:Config.url +'/faq',
    Cma:Config.url +'/cms',
    CMS:Config.url + '/user/privacy-policy/:id',
    AppPrivacyPolicyCMS:Config.url ="/user/privacy-policy/:id", 
    AppTermCondition:Config.url ="/user/terms-and-conditions/:id", 
    AppAboutUs:Config.url ="/user/about-us/:id", 
    UserFaq:Config.url ="/user/faq/:id",
    SelectAddress:Config.url ="/select-address",
    SelectExcel:Config.url ='/select-excel-address',
    RequestQuoteCreate:Config.url ="/create-request-quote",
    RequestQuoteCreateSecond:Config.url ="/incorrect-excel",
    MyQuote:Config.url ="/my-quotation",
    Drafts:Config.url ="/drafts",
    Viewquote:Config.url ="/view-quotation/:id",
    QuotationCheckout:Config.url ="/quotation-checkout/:id",
    QuotationPdfPreview:Config.url ="/quotation-pdf-preview/:id",
    OrderPdfPreview:Config.url ="/order-pdf-preview/:id",
    Order:Config.url ="/order",
    OrderDetail:Config.url ="/order-detail/:id",
    OrderCheckout:Config.url ="/order-checkout/:id",
    Notification:Config.url ="/notification",
    QutationHistory:Config.url ="/history/:id",
    AddressList:Config.url ='/address',
    AddressCreate:Config.url ='/address/new',
    AddressEdit:Config.url ='/address/edit/:id',
    CategoryList:Config.url ='/category',
    UpdatecategoryList:Config.url ='/update-category',
    Paymentsuccess:Config.url = "/success",
    Paymentscancel:Config.url = "/cancel",
    PaymentFailed:Config.url = "/failed",
    DraftPage:Config.url ="/draft-page",
}
